// ** React Imports
import { Navigate } from "react-router-dom";
import { Suspense } from "react";
import useUser from "../../../utility/context/useUserContext";

const PrivateRoute = ({ children, route }) => {
  // ** Hooks & Vars
  const { user } = useUser();
  const dateNow = new Date().getTime();
  const authDate = Number(user?.exp ?? 0);

  if (route) {
    let restrictedRoute = false;

    if (route.meta) {
      action = route.meta.action;
      resource = route.meta.resource;
      restrictedRoute = route.meta.restricted;
    }
    if (!user.token || dateNow > authDate) {
      return <Navigate to="/login" />;
    }
    if (user && restrictedRoute) {
      return <Navigate to="/home" />;
    }
  }

  return <Suspense fallback={null}>{children}</Suspense>;
};

export default PrivateRoute;
